import React from 'react';
import { Button } from '@mui/material';
import styles from './errorSection.module.css';

interface ErrorSectionProps {
    handleClick: () => void;
}

export const ErrorSection:React.FC<ErrorSectionProps> = ({handleClick}) => {
    return (
        <div className={styles.errorContainer}>
            <div className={styles.errorBox}>
                <p className={styles.errorTitle}>Error: Unable to retrieve data.</p>
                <p className={styles.errorSubtitle}>Please try again in a moment.</p>

                <Button variant="text"
                    className={styles.outlinedGreen}
                    onClick={handleClick}
                >
                    TRY AGAIN
                </Button>
            </div>
        </div>
    )
}
